export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6196.6d082251.jpg";